// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"2f4135c7","974":"f27bee5b"}[chunkId] + ".chunk.css";
};